import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { AllItemsGridDirective } from '@portal-core/ui/grid/directives/all-items-grid/all-items-grid.directive';

@NgModule({
  declarations: [
    AllItemsGridDirective,
  ],
  imports: [
    CommonModule,
    MatPaginatorModule
  ],
  exports: [
    AllItemsGridDirective
  ]
})
export class AllItemsGridDirectiveModule { }
